"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Search = exports.Plus = exports.CalendarIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@material-ui/core/styles");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* eslint-disable max-len */

var iconsColors = (0, _styles.makeStyles)(function (theme) {
  return {
    cls1: {
      fill: theme.palette.primary.main
    },
    cls2: {
      fill: theme.palette.secondary.mainDark
    },
    cls3: {
      fill: 'none',
      stroke: theme.palette.primary.main
    },
    cls4: {
      fill: 'none',
      stroke: theme.palette.secondary.mainLight
    }
  };
});
var CalendarIcon = function CalendarIcon(_ref) {
  var label = _ref.label;
  var classes = iconsColors();
  return /*#__PURE__*/_react.default.createElement("svg", {
    viewBox: "0 0 23 24",
    className: "calendarIcon",
    alt: label,
    width: "23",
    height: "24"
  }, /*#__PURE__*/_react.default.createElement("path", {
    className: classes.cls2,
    d: "M21,2.2H2c-1.1,0-2,0.9-2,2c0,0,0,0,0,0V22c0,1.1,0.9,2,2,2H21c1.1,0,2-0.9,2-2V4.2C23,3.1,22.1,2.2,21,2.2z M21.5,22c0,0.3-0.2,0.5-0.5,0.5H2c-0.3,0-0.5-0.2-0.5-0.5V4.2c0-0.3,0.2-0.5,0.5-0.5H21c0.3,0,0.5,0.2,0.5,0.5V22z"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "10",
    y: "16",
    className: classes.cls2,
    width: "3",
    height: "3"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "10",
    y: "12",
    className: classes.cls2,
    width: "3",
    height: "3"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "10",
    y: "8",
    className: classes.cls2,
    width: "3",
    height: "3"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "5",
    y: "16",
    className: classes.cls2,
    width: "3",
    height: "3"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "5",
    y: "12",
    className: classes.cls2,
    width: "3",
    height: "3"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "5",
    y: "8",
    className: classes.cls2,
    width: "3",
    height: "3"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "15",
    y: "16",
    className: classes.cls2,
    width: "3",
    height: "3"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "15",
    y: "12",
    className: classes.cls2,
    width: "3",
    height: "3"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "15",
    y: "8",
    className: classes.cls2,
    width: "3",
    height: "3"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: classes.cls2,
    d: "M5,5c0,0.5,0.4,1,1,1c0.5,0,1-0.4,1-1l0-4c0-0.5-0.4-1-1-1C5.5,0,5,0.4,5,1L5,5z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: classes.cls2,
    d: "M10.5,5c0,0.5,0.4,1,1,1c0.5,0,1-0.4,1-1l0-4c0-0.5-0.4-1-1-1c-0.5,0-1,0.4-1,1L10.5,5z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: classes.cls2,
    d: "M16,5c0,0.5,0.4,1,1,1c0.5,0,1-0.4,1-1l0-4c0-0.5-0.4-1-1-1s-1,0.4-1,1L16,5z"
  }));
};
exports.CalendarIcon = CalendarIcon;
CalendarIcon.propTypes = {
  label: _propTypes.default.string
};
var Plus = function Plus() {
  var classes = iconsColors();
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "21.355",
    height: "21.355",
    viewBox: "0 0 21.355 21.355"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "Group_144",
    "data-name": "Group 144",
    transform: "translate(2 2)"
  }, /*#__PURE__*/_react.default.createElement("line", {
    id: "Line_47",
    "data-name": "Line 47",
    y2: "17.355",
    transform: "translate(8.678 0)",
    className: classes.cls4,
    strokeLinecap: "round",
    strokeWidth: "4"
  }), /*#__PURE__*/_react.default.createElement("line", {
    id: "Line_48",
    "data-name": "Line 48",
    x2: "17.355",
    transform: "translate(0 8.678)",
    className: classes.cls4,
    strokeLinecap: "round",
    strokeWidth: "4"
  })));
};
exports.Plus = Plus;
var Search = function Search() {
  var classes = iconsColors();
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "22.302",
    height: "22.303",
    viewBox: "0 0 22.302 22.303"
  }, /*#__PURE__*/_react.default.createElement("path", {
    id: "Search_Icon",
    "data-name": "Search Icon",
    d: "M17.7,15.653a9.446,9.446,0,0,0,1.951-5.818A9.785,9.785,0,0,0,9.9,0,9.9,9.9,0,0,0,0,9.835,9.9,9.9,0,0,0,9.9,19.67a9.293,9.293,0,0,0,5.854-1.939l4.182,4.156a1.353,1.353,0,0,0,1.951,0,1.333,1.333,0,0,0,0-1.939ZM9.9,16.761A7,7,0,0,1,2.788,9.835a7.109,7.109,0,0,1,14.218,0A7,7,0,0,1,9.9,16.761Z",
    transform: "translate(0 -0.001)",
    className: classes.cls2
  }));
};
exports.Search = Search;